import _typeof from '@babel/runtime/helpers/esm/typeof';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _inheritsLoose from '@babel/runtime/helpers/esm/inheritsLoose';
import React from 'react';
import 'prop-types';
import { LoadingSpinner } from '@zillow/loading-spinner';
import _wrapNativeSuper from '@babel/runtime/helpers/esm/wrapNativeSuper';

var AsyncComponent = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AsyncComponent, _React$Component);

  function AsyncComponent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      Component: null
    };
    return _this;
  }

  var _proto = AsyncComponent.prototype;

  /* As of React 16.4 this lifecycle method will be deprecated.
      This should move to componentDidMount while this is probably harmless,
      it will certainly require regression testing.
      https://medium.com/@baphemot/whats-new-in-react-16-3-d2c9b7b6193b
  */
  _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
    var _this2 = this;

    var _this$props = this.props,
        loader = _this$props.loader,
        onLoadError = _this$props.onLoadError,
        initialProps = _objectWithoutProperties(_this$props, ["loader", "onLoadError"]);

    Promise.resolve(initialProps).then(loader).then(function (exported) {
      // bridge the gap between native import and tree shaking
      var Component = _typeof(exported) === 'object' ? exported.default : exported;

      _this2.setState({
        Component: Component
      });
    }).catch(function (err) {
      if (err.name !== 'SkipLoadError') {
        onLoadError(err);
      }
    });
  };

  _proto.render = function render() {
    var Component = this.state.Component;

    var _this$props2 = this.props,
        loader = _this$props2.loader,
        onLoadError = _this$props2.onLoadError,
        renderPlaceholder = _this$props2.renderPlaceholder,
        placeholderHeight = _this$props2.placeholderHeight,
        placeholderBackgroundColor = _this$props2.placeholderBackgroundColor,
        passedProps = _objectWithoutProperties(_this$props2, ["loader", "onLoadError", "renderPlaceholder", "placeholderHeight", "placeholderBackgroundColor"]);

    if (Component) {
      return /*#__PURE__*/React.createElement(Component, passedProps);
    }

    if (renderPlaceholder) {
      return renderPlaceholder();
    }

    if (renderPlaceholder === false) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        height: placeholderHeight,
        backgroundColor: placeholderBackgroundColor,
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(LoadingSpinner, {
      large: true
    }));
  };

  return AsyncComponent;
}(React.Component);
AsyncComponent.propTypes =  {};
AsyncComponent.defaultProps = {
  onLoadError: function onLoadError(err) {
    // eslint-disable-next-line no-console
    console.error(err);
  },
  renderPlaceholder: undefined,
  placeholderHeight: 300,
  placeholderBackgroundColor: '#fff'
};

/* eslint-disable zillow/import/prefer-default-export */
var SkipLoadError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(SkipLoadError, _Error);

  function SkipLoadError(message) {
    var _this;

    _this = _Error.call(this, message) || this;
    _this.name = 'SkipLoadError';
    return _this;
  }

  return SkipLoadError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export default AsyncComponent;
export { AsyncComponent, SkipLoadError };
